module.exports = "/images/vendor/greenmotion-shared/svgs/cards/American Express.svg?315658f3eb99d86ef690b57bce2bad5d";